// extracted by mini-css-extract-plugin
module.exports = {"Updated":"Updated_Updated__nmMA7"};